module.exports = __webpack_public_path__ + "static/media/13.9d9c9007.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/13.png
// module id = 972
// module chunks = 0